import { config } from "../../../config";

function getMimeType(fileName: string): string {
  const ext = fileName.split(".").pop()?.toLowerCase();
  switch (ext) {
    case "jpg":
    case "jpeg":
      return "image/jpeg";
    case "png":
      return "image/png";
    case "webp":
      return "image/webp";
    case "svg":
      return "image/svg+xml";
    case "bmp":
      return "image/bmp";
    case "gif":
      return "image/gif";
    case "avif":
      return "image/avif";
    case "pdf":
      return "application/pdf";
    case "doc":
    case "docx":
      return "application/msword";
    default:
      return "application/octet-stream";
  }
}

export async function urlToFile(url: string, filename: string): Promise<File> {
  const res = await fetch(url);
  const blob = await res.blob();
  const mimeType = getMimeType(filename);
  return new File([blob], filename, { type: mimeType });
}

export async function convertArrayToFiles(paths: string[]) {
  const files = await Promise.all(
    paths.map(async (path) => {
      const originalName = path.split("/").pop() || "image.jpg";

      const cleanName = originalName.split("_").pop() || originalName;

      const fullUrl = `${config.serverURL}public/${path}`;
      return await urlToFile(fullUrl, cleanName);
    })
  );
  return files;
}
export async function convertToFile(path: string): Promise<File> {
  const fileName = path.split("/").pop() || "file.dat";
  const fullUrl = `${config.serverURL}${path}`;
  return await urlToFile(fullUrl, fileName);
}
